// src/components/GoogleVerification.js
import React from "react";

function GoogleVerification() {
  return <>google-site-verification: google5d2f6ca15383c900.html</>;
}

export default GoogleVerification;
